export enum PropertyContentViewSortOptionsEnum {
  LastUpdated = "updatedAt",
  DateAdded = "createdAt",
  PriceRangeMinAsc = "startingPriceAsc",
  PriceRangeMinDesc = "startingPriceDesc",
  PriceRangeMaxAsc = "maxPriceAsc",
  PriceRangeMaxDesc = "maxPriceDesc",
  YearBuilt = "yearBuilt",
}

export const PROPERTY_VIEW_SORT_VALUES: Record<
  PropertyContentViewSortOptionsEnum,
  { fieldName: string; sortOrder: 1 | -1 }
> = {
  [PropertyContentViewSortOptionsEnum.LastUpdated]: {
    fieldName: "updatedAt",
    sortOrder: -1,
  },
  [PropertyContentViewSortOptionsEnum.DateAdded]: {
    fieldName: "createdAt",
    sortOrder: -1,
  },
  [PropertyContentViewSortOptionsEnum.PriceRangeMinAsc]: {
    fieldName: "priceRange.min",
    sortOrder: 1,
  },
  [PropertyContentViewSortOptionsEnum.PriceRangeMinDesc]: {
    fieldName: "priceRange.min",
    sortOrder: -1,
  },
  [PropertyContentViewSortOptionsEnum.PriceRangeMaxAsc]: {
    fieldName: "priceRange.max",
    sortOrder: 1,
  },
  [PropertyContentViewSortOptionsEnum.PriceRangeMaxDesc]: {
    fieldName: "priceRange.max",
    sortOrder: -1,
  },
  [PropertyContentViewSortOptionsEnum.YearBuilt]: {
    fieldName: "yearBuilt",
    sortOrder: -1,
  },
};